// Eastern-time helpers. Rosie is locked to America/New_York regardless of the
// device timezone -- every display and every datetime-local round trip must go
// through these instead of relying on the browser's local zone.

const ET = 'America/New_York';

// Returns a Date whose LOCAL fields (getHours, getDay, ...) equal the Eastern
// wall-clock reading of the given instant. Feed the result to date-fns format()
// or local getters; do NOT use it as a real instant (toISOString, getTime).
function toET(dateLike) {
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  if (isNaN(d)) return d;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: ET,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  }).formatToParts(d).reduce((acc, p) => { acc[p.type] = p.value; return acc; }, {});
  return new Date(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    parts.hour === '24' ? 0 : Number(parts.hour),
    Number(parts.minute),
    Number(parts.second)
  );
}

// Today's date in Eastern time as 'YYYY-MM-DD'.
function todayET() {
  const w = toET(new Date());
  const mm = String(w.getMonth() + 1).padStart(2, '0');
  const dd = String(w.getDate()).padStart(2, '0');
  return `${w.getFullYear()}-${mm}-${dd}`;
}

// Converts an Eastern wall-clock string ('YYYY-MM-DDTHH:mm' or with seconds,
// as produced by datetime-local inputs) to a UTC ISO instant, handling
// EST/EDT for that specific date. Returns null for empty input.
function etToISO(naive) {
  if (!naive) return null;
  const [datePart, timePart = '00:00'] = naive.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const [hh, mm, ss = 0] = timePart.split(':').map(Number);
  const wallUTC = Date.UTC(y, m - 1, d, hh, mm, ss);
  // Start from the wall time as if it were UTC, then correct by however far
  // the ET reading of that guess drifts. Two passes settle DST boundaries.
  let utc = wallUTC;
  for (let i = 0; i < 2; i++) {
    const w = toET(new Date(utc));
    const drift = Date.UTC(
      w.getFullYear(), w.getMonth(), w.getDate(),
      w.getHours(), w.getMinutes(), w.getSeconds()
    ) - wallUTC;
    utc -= drift;
  }
  return new Date(utc).toISOString();
}

// Parses a date-only value (DATE column, 'YYYY-MM-DD' or ISO-midnight string)
// as a plain calendar date, immune to timezone shifts. Feed to date-fns format().
function parseDateOnly(s) {
  const [y, m, d] = String(s).slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}

module.exports = { toET, todayET, etToISO, parseDateOnly };
